import '@style/common/main-style'

import '@style/common/button.css'
import '@style/common/breadcrumbs.css'

import '@core/components/template/skeleton/card'
import '@core/components/template/pagination'

import '@style/components/template/pagination/page.css'
import '@style/components/template/Card/index.css'

import './index.css'

import { deletePage } from '@utils/browserTest.ts'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'
import { generateTutorialsElements } from '@core/views/tutorials/generate.ts'
import { addQueryParam, updatePageTitle } from '@core/utils/url.ts'
import { useChaptersCourses } from '@core/composables/useChaptersCourses.ts'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(() => {
    if (import.meta.env.DEV) {
      generateTutorialsElements(document)
    }

    removeCurrentPageClickEvent()

    const pageNumber = new URLSearchParams(window.location.search).get('page') ?? '1'
    updatePageTitle(`Catalogue des tutoriels - Page ${pageNumber}`)

    const sortSelect = document.querySelector<HTMLSelectElement>('select#sort')!
    const difficultySelect = document.querySelector<HTMLSelectElement>('select#difficulty')!

    useChaptersCourses.updateSelectValues(sortSelect, difficultySelect)
    sortSelect.addEventListener('change', function () {
      addQueryParam('sort', this.value)
      useChaptersCourses.loadElements('tutorials', {
        sort: this.value,
        pageNumber,
        difficulty: difficultySelect.value,
      })
    })
    difficultySelect.addEventListener('change', function () {
      addQueryParam('difficulty', this.value)
      useChaptersCourses.loadElements('tutorials', {
        difficulty: this.value,
        pageNumber,
        sort: sortSelect.value,
      })
    })
    useChaptersCourses.loadElements('tutorials', {
      sort: sortSelect.value,
      pageNumber,
      difficulty: difficultySelect.value,
    })
  })
})
